module.exports ={
    shops: {
        all: 'All stores',
        statusOpt:[
            {
                label: 'All stores',
                value: true
            },{
                label: 'Closed stores',
                value: false
            }
        ],
        add:'Add',
        addTip: {
            success: 'Your store is added successfully',
            exist: 'The store already exists',
            fail:'Adding the store failed',
            permission: 'You do not have permission to add stores'
        },
        find:'Search for stores',
        addTitle: 'Add a store',
        storeId: 'Store number',
        no:'Number: ',
        storeIdMsg: 'Please enter store number',
        storeIdMsg1: 'Please enter numbers or letters',
        storeIdExist: 'The store already exists',
        storeIdFail: 'Failed to get, please re-enter',
        storeName: 'Store name',
        storeNameMsg: 'Please enter store name',
        storeAddress: 'Address',
        address: 'Address: ',
        storeAddressMsg: 'Please enter Address ',
        serviceAddress: 'Server address',
        serviceAddressMsg: 'Please enter server address',
        storeImg: 'Cover image',
        storeImgMsg: 'Please upload cover image',
        cancel: 'Cancel',
        save: 'Save',
        uploadMsg: 'Upload a new cover image',
        uploadType:'Uploading images can only be in JPG or PNG format!',
        uploadSizeLt: 'Image size must be within 370*370!',
        uploadFailed:'Uploading image failed',
        sure: 'OK',
        status: {
            on: 'Opened',
            off: 'Closed'
        },
        noData: 'No data',
        submiting: 'Saving...',
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/shops.js